import type { ChatEditSchema } from '@repo/schemas/chat/chatEdit';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ChatService } from './chatService';
import { ChatKey } from './keys';

export function useEditChat() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ChatEditSchema) => ChatService.editChat(data).then((response) => response.data),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [ChatKey.CHAT_LAST_CONVERSATIONS_INFINITE],
        exact: false,
      });
      queryClient.invalidateQueries({
        queryKey: [ChatKey.CHAT, data.id],
      });
    },
  });
}
